var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteSmallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete-small-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1283",
    d: "M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z",
    fill: "#CC8552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5103",
    d: "M20 11.2H24V12.8H22.4V23.2C22.4 23.3051 22.3793 23.4091 22.3391 23.5061C22.2989 23.6032 22.24 23.6914 22.1657 23.7657C22.0914 23.84 22.0032 23.8989 21.9061 23.9391C21.8091 23.9793 21.7051 24 21.6 24H10.4C10.1878 24 9.98434 23.9157 9.83431 23.7657C9.68429 23.6157 9.6 23.4122 9.6 23.2V12.8H8V11.2H12V8.8C12 8.58783 12.0843 8.38434 12.2343 8.23431C12.3843 8.08429 12.5878 8 12.8 8H19.2C19.4122 8 19.6157 8.08429 19.7657 8.23431C19.9157 8.38434 20 8.58783 20 8.8V11.2ZM20.8 12.8H11.2V22.4H20.8V12.8ZM13.6 15.2H15.2V20H13.6V15.2ZM16.8 15.2H18.4V20H16.8V15.2ZM13.6 9.6V11.2H18.4V9.6H13.6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSmallIcon);
export default __webpack_public_path__ + "static/media/delete-small-icon.eb9a23356df524899ecdd207bdd744ff.svg";
export { ForwardRef as ReactComponent };